import { render, staticRenderFns } from "./ProofreadingEditor.vue?vue&type=template&id=9fb248b2&scoped=true"
import script from "./ProofreadingEditor.vue?vue&type=script&lang=ts"
export * from "./ProofreadingEditor.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingEditor.vue?vue&type=style&index=0&id=9fb248b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb248b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fb248b2')) {
      api.createRecord('9fb248b2', component.options)
    } else {
      api.reload('9fb248b2', component.options)
    }
    module.hot.accept("./ProofreadingEditor.vue?vue&type=template&id=9fb248b2&scoped=true", function () {
      api.rerender('9fb248b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/ProofreadingEditor.vue"
export default component.exports